export const handleShare = ({
  message,
  url,
}: {
  message: string;
  url: string;
}): Promise<void> | void => {
  // In Chrome browsers for desktop, this feature is only supported on ChromeOS and Windows.
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
  // TODO: https://rbictg.atlassian.net/browse/BKPE-4490
  return (
    navigator.share &&
    navigator.share({
      text: message,
      url,
    })
  );
};
